<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center pb-0" style="gap: 12px;">
        <div>
          <div class="text-h6">Registros de estudiantes en los programas</div>
          <!-- <div class="text-body-2 text--secondary">
            Opciones de filtros
          </div> -->
        </div>
        <v-spacer></v-spacer> 
        <v-chip color="blue-grey lighten-5" class="blue-grey--text text--darken-3" small>
          encontrados: {{ inscripciones.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-1 mt-0">
        <v-row dense class="mb-0 py-2" style="background: #fffeff;border: 1px dashed #d6b2d6">
          <v-col cols="12" md="2">
            <v-text-field
              v-model="fechaInicio"
              dense
              outlined
              type="date"
              label="Inscripciones desde:"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="fechaFin"
              dense
              outlined
              type="date"
              label="Inscripciones hasta:"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-combobox 
              v-model="sedeSeleccionada" 
              :items="$store.state.CARGOS"  
              item-text="nombre"
              hide-details
              outlined
              dense
              label="Sede de programas:"
              clearable
            ></v-combobox> 
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-combobox 
              v-model="asesor" 
              :items="asesores" 
              :loading="isLoadingAsesores"
              :disabled="!sedeSeleccionada || !sel_todos_asesores"
              hide-details
              outlined
              dense
              label="Asesor:"
              :clearable="sel_todos_asesores"
            ></v-combobox>
          </v-col>

          <v-col cols="12" md="4" lg="2">
            <v-combobox 
              v-model="estado_administrativo" 
              :items="estados_admins"  
              :disabled="!mostrarEstadoAdmin"
              hide-details
              outlined
              dense
              clearable
              label="Estado Administrativo:"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="4" lg="2">
            <v-combobox 
              v-model="unidad_negocio" 
              :items="unidades"  
              hide-details
              outlined
              dense
              clearable
              label="Unidad negocio:"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-combobox 
              v-model="convenio" 
              :items="convenios"  
              hide-details
              outlined
              dense
              clearable
              label="Convenio:"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="4" lg="3"> 
            <v-combobox 
              v-model="xcategoria" 
              :items="xcategorias"  
              hide-details
              item-text="categoria"
              item-value="categoria_id"
              outlined
              dense
              clearable
              label="Categorias:"
              multiple
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-btn color="green" class="text-none" dark depressed :loading="loading" @click="listar">
              <v-icon left>mdi-refresh</v-icon>
              Aplicar filtros
            </v-btn> 
          </v-col>
        </v-row>
        
        <v-chip v-if="terminos" color="blue lighten-5" class="blue--text text--darken-3" small>
          {{ terminos.title || 'Terminos' }} - {{ terminos.version_code || 'S/V' }}
        </v-chip> 

        <v-alert v-if="msg" dense outlined type="warning" class="mb-3">
          {{ msg }}
        </v-alert>

        <v-row dense class="mb-3">
          <v-col
            v-for="card in cardsGerencia"
            :key="card.titulo"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card outlined class="gerencia-card">
              <v-card-title
                class="py-2 d-flex align-center flex-nowrap gerencia-card__header"
                :class="`${card.color} lighten-5`"
              >
                <v-avatar :color="`${card.color} lighten-5`" size="32" class="mr-2 flex-shrink-0">
                  <v-icon :color="card.color" small>{{ card.icono }}</v-icon>
                </v-avatar>
                <div class="min-width-0 flex-grow-1 mr-1">
                  <div class="text-subtitle-2 font-weight-bold text-truncate" :title="card.titulo">{{ card.titulo }}</div>
                  <div class="text-caption text--secondary line-height-tight">{{ card.items.length }} grupos</div>
                </div>
                <div class="d-flex align-center flex-shrink-0">
                  <div class="text-subtitle-1 font-weight-bold mr-1">{{ card.total }}</div>
                  <v-btn
                    icon
                    x-small
                    :color="esVistaGrafico(card.titulo) ? card.color : 'grey darken-1'"
                    :title="esVistaGrafico(card.titulo) ? 'Ver en lista' : 'Ver en gráfico'"
                    @click="toggleVistaGrafico(card.titulo)"
                  >
                    <v-icon small>
                      {{ esVistaGrafico(card.titulo) ? 'mdi-format-list-bulleted' : 'mdi-chart-bar' }}
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="!esVistaGrafico(card.titulo) && card.items.length > limiteItemsCard"
                    icon
                    x-small
                    :title="cardExpandida(card.titulo) ? 'Ver menos' : 'Ver todos'"
                    @click="toggleCardGerencia(card.titulo)"
                  >
                    <v-icon small>
                      {{ cardExpandida(card.titulo) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </v-btn>
                  <div v-else-if="!esVistaGrafico(card.titulo)" style="width: 18px;"></div>
                </div>
              </v-card-title>
              <v-divider></v-divider>
              <template v-if="esVistaGrafico(card.titulo)">
                <div class="pa-2 gerencia-card__chart d-flex align-center justify-center">
                  <component
                    :is="card.items.length > 6 ? 'ChartHorizontalBar' : 'ChartDoughnut'"
                    v-if="card.items.length"
                    :chart-data="obtenerChartData(card)"
                    :chart-options="obtenerChartOptions(card)"
                    style="width: 100%; height: 210px; position: relative;"
                  />
                  <div v-else class="text-body-2 text--secondary text-center py-4">
                    Sin datos para graficar
                  </div>
                </div>
              </template>
              <template v-else>
                <v-list dense class="py-0 gerencia-card__list">
                  <v-list-item
                    v-for="item in itemsVisiblesCard(card)"
                    :key="`${card.titulo}-${item.nombre}`"
                    class="px-3"
                  >
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="text-body-2 text-truncate" :title="item.nombre"> 
                        <span> {{ item.nombre }} </span>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0 ml-2">
                      <v-chip :color="`${card.color} lighten-5`" :class="`${card.color}--text text--darken-3`" small>
                        {{ item.total }}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="!card.items.length" class="px-3">
                    <v-list-item-content class="py-2">
                      <v-list-item-title class="text-body-2 text--secondary">
                        Sin datos para mostrar
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
            </v-card>
          </v-col>
        </v-row>

        <p class="blue darken-2">.</p>

        <v-btn
          v-if="is_descargar_inscritos"
          color="green"
          dark
          outlined
          small
          depressed
          :disabled="loading || !inscripcionesFiltradas.length"
          @click="descargarCSV">
        <v-icon left>mdi-download</v-icon>
          Descargar
        </v-btn>

        <div>
          <v-text-field
            v-if="ver_tabla_inscritos"
            v-model="search"
            dense
            outlined
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Buscar estudiante"
            hide-details
          />
        </div>
        <v-data-table
          v-if="ver_tabla_inscritos"
          :headers="headers"
          :items="inscripcionesFiltradas"
          :loading="loading"
          :items-per-page="25"
          dense
          class="elevation-1"
          loading-text="Cargando inscripciones..."
          no-data-text="No hay inscripciones para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>

          <template v-slot:[`item.estudiante_nombre`]="{ item }">
            {{ item.estudiante_nombre || '-' }}
          </template>

          <template v-slot:[`item.programa_nombre`]="{ item }">
            <span style="min-width: 300px;display: block;"> {{ item.programa_nombre || '-' }} </span>
          </template>

          <template v-slot:[`item.sede_nombre`]="{ item }">
            {{ item.sede_nombre || '-' }}
          </template>

          <template v-slot:[`item.fecha_inscripcion`]="{ item }">
            {{ parseFecha(item.fecha_inscripcion) }}
          </template>

          <template v-slot:[`item.asesor_nombre`]="{ item }">
            {{ item.asesor_nombre || '-' }}
          </template>

          <template v-slot:[`item.estado_administrativo_id`]="{ item }">
            <span> {{ obtenerTextoEstado(item) }} </span>
          </template>  

          <template v-slot:[`item.estado_programa`]="{ item }">
            <span> {{ item.estado_programa_padre }} ({{ item.estado_programa }}) </span>
          </template>  
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { reporte_inscripciones_v1, estados_admins, getunidades, getInstituciones, ver_todos_asesores, ver_todas_sedes, ver_tabla_de_inscritos, descargar_inscritos, UNIDADES_CON_ESTADO_ADMINISTRATIVO } from './utils';
import { cardsInscripcionesGerencia } from './reportes_dash';
import { HorizontalBar, Doughnut } from 'vue-chartjs';

const ChartHorizontalBar = {
  extends: HorizontalBar,
  props: ['chartData', 'chartOptions'],
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.$data._chart?.destroy();
        this.renderChart(this.chartData, this.chartOptions);
      },
    },
  },
};

const ChartDoughnut = {
  extends: Doughnut,
  props: ['chartData', 'chartOptions'],
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.$data._chart?.destroy();
        this.renderChart(this.chartData, this.chartOptions);
      },
    },
  },
};

  export default {
    components: {
      ChartHorizontalBar,
      ChartDoughnut,
    },
    data() {
      return {
        loading: false,
        isLoadingAsesores: false,
        msg: '',
        search: '',
        fechaInicio: '',
        fechaFin: '',
        sedeSeleccionada: null,
        asesor: null,
        asesores: [],
        terminos: null,
        inscripciones: [],
        estado_administrativo: null,
        cardsExpandidas: {},
        vistasGrafico: {},
        limiteItemsCard: 6,
        unidad_negocio: null,
        unidades: [
          {id:1, text:'esam'},
          {id:2, text:'cca'},
        ],
        convenio: null,
        convenios: [
          {id:9, text:'Siglo xx'},
          {id:301, text:'Upi'},
        ],
        xcategoria:null,
        xcategorias:[],
        sel_todos_asesores: ver_todos_asesores(this),
        ver_todas_las_sedes: ver_todas_sedes(this),
        ver_tabla_inscritos: ver_tabla_de_inscritos(this),
        is_descargar_inscritos: descargar_inscritos(this),
        headers: [
          { text: 'Fecha inscripción', value: 'fecha_inscripcion', width: 150 },
          { text: 'Estudiante', value: 'estudiante_nombre' },
          { text: 'Programa', value: 'programa_nombre', width: 260 },
          { text: 'Sede', value: 'sede_nombre', width: 180 },
          { text: 'Asesor', value: 'asesor_nombre', width: 180 },
          { text: 'Estado Administrativo', value: 'estado_administrativo_id', width: 130 },
          { text: 'Plan de cobros', value: 'plan_cobro', width: 130 },
          { text: 'Estado del programa', value: 'estado_programa', width: 130 },
          // { text: 'Términos', value: 'acepto_terminos', width: 130 },
        ],
        estados_admins: estados_admins()
      };
    },
    computed: { 
      mostrarEstadoAdmin() {
        if (!this.unidad_negocio) return true;
        return UNIDADES_CON_ESTADO_ADMINISTRATIVO.includes(this.unidad_negocio.id);
      },
      inscripcionesFiltradas() {
        if (!this.search) return this.inscripciones;
        const q = this.search.toLowerCase();
        return this.inscripciones.filter((item) => {
          return [
            item.inscripcion_id,
            item.fecha_inscripcion,
            item.estudiante_nombre,
            item.programa_nombre,
            item.sede_nombre,
            item.asesor_nombre,
            item.categoria,
            item.unidad,
            item.convenio,
            item.plan_cobro,
            item.tipo_plan,
            item.tipo_plan_id,
            item.tipo_inscripcion,
            item.area,
            item.estado_administrativo_id,
            item.estado_ins,
            this.obtenerTextoEstado(item),
            item.estado_programa_padre,
            item.estado_programa_padre_id,
            item.estado_programa,
            item.estado_programa_id,
            item.fecha_aceptacion_terminos,
            item.estado_encolado != null ? 'acepto aceptó si' : 'no acepto aceptó',
            item.correo != null ? 'correo enviado si' : 'correo no enviado',
            item.correo,
            item.correo_enviado_el,
          ].some((value) => String(value || '').toLowerCase().includes(q));
        });
      },
      cardsGerencia() {
        return cardsInscripcionesGerencia(this.inscripcionesFiltradas, {
          mostrarEstadoIns: !this.mostrarEstadoAdmin,
        }).map((card) => ({
          ...card,
          total: card.items.reduce((sum, item) => sum + item.total, 0),
        }));
      },
    },
    watch: {
      '$store.state.CARGO': function() {
        this.listar();
      },
      sedeSeleccionada: function() {
        this.listar_asesores();
      },
      unidad_negocio: function(nuevaUnidad) {
        if (nuevaUnidad && !UNIDADES_CON_ESTADO_ADMINISTRATIVO.includes(nuevaUnidad.id)) {
          this.estado_administrativo = null;
        }
      },
    },
    methods: {
      obtenerTextoEstado(item) {
        /* if (item.unidad_id && !UNIDADES_CON_ESTADO_ADMINISTRATIVO.includes(item.unidad_id)) {
          if (item.estado_ins === 1) return 'Inscrito';
          if (item.estado_ins === 0) return 'Pre inscrito';
          return item.estado_ins != null ? `Otros (${item.estado_ins})` : '-';
        } */
        return this.estados_admins.find(x => x.id == item.estado_administrativo_id)?.text || '-';
      },
      async listar() { 
        this.loading = true;
        this.msg = '';
        this.inscripciones = [];

        try { 
          const qu = {
            desde: this.fechaInicio+'T00:00:00',
            hasta: this.fechaFin+'T23:59:59',
          }
          
          if(this.asesor){
            qu.asesor_id = this.asesor.id;
          }
          if(this.estado_administrativo && this.mostrarEstadoAdmin){
            qu.estado_administrativo_id = this.estado_administrativo.id;
          }
          if(this.unidad_negocio){
            qu.unidad_negocio_id = this.unidad_negocio.id;
          }
          if(this.convenio){
            qu.convenio_id = this.convenio.id;
          }
          if(this.sedeSeleccionada){
            qu.sede_id = [this.sedeSeleccionada.idsede];
          }
          if(!this.sedeSeleccionada && !this.ver_todas_las_sedes){
            const ids = this.$store.state.CARGOS.map(x => (x.idsede))
            qu.sede_id = ids;
          }

          const res = await reporte_inscripciones_v1(qu);
          let ins = Array.isArray(res) ? res : [];

          if (this.xcategoria && this.xcategoria.length > 0) {
            ins = ins.filter(x =>
              this.xcategoria.some(c => c.categoria_id === x.categoria_id)
            )
          }

          this.inscripciones = ins;
          const categorias = [
            ...new Map(
              ins.map(item => [
                item.categoria_id,
                {
                  categoria: item.categoria,
                  categoria_id: item.categoria_id
                }
              ])
            ).values()
          ]; 
          
          categorias.forEach(x=>{
            const ex = this.xcategorias.find(c=>c.categoria_id == x.categoria_id);
            if(!ex) this.xcategorias.push(x)
          }) 

        } catch (e) {
          window.console.error(e);
          this.msg = 'No se pudo cargar la lista de inscripciones y aceptaciones';
        } finally {
          this.loading = false;
        }
      },
      async listar_unidades(){
        const r = await getunidades()
        if(r){
          const units =r.map(x=>({ ...x, text: x.nombre }))
          this.unidades = units
        } 
      },
      async listar_convenios(){
        const r = await getInstituciones(this)
        if(r){
          const conves = r.filter(x=>x.convenio)
          const cvs = conves.map(x=>({...x, text: `(${x.abreviatura}) ${x.nombre}`}))
          this.convenios = cvs
        } 
      },
      setFechasDefault() {
        const fin = new Date();
        const inicio = new Date();
        inicio.setDate(1);
        this.fechaInicio = this.formatoFechaInput(inicio);
        this.fechaFin = this.formatoFechaInput(fin);
      },
      habilitarcampos(){
        /* if(!this.ver_todo || !this.ver_todas_las_sedes){
          const sede = this.$store.state.CARGOS[0]
          this.sedeSeleccionada = sede;
        } */
      },
      formatoFechaInput(date) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      },
      descargarCSV() {
        if (!this.inscripcionesFiltradas.length) return;

        // Obtener todas las propiedades únicas presentes en la respuesta
        const allKeys = Array.from(
          new Set(this.inscripcionesFiltradas.flatMap(item => Object.keys(item)))
        );

        // Separar campos normales de los de baja prioridad (_id, _por, _ins)
        const isLowPriority = (key) => /_id$|_por$|_ins$/.test(key);
        const mainKeys = allKeys.filter(k => !isLowPriority(k));
        const lowPriorityKeys = allKeys.filter(k => isLowPriority(k));

        const orderedKeys = [...mainKeys, ...lowPriorityKeys];

        const rows = this.inscripcionesFiltradas.map((item) => {
          return orderedKeys.map((key) => {
            let val = item[key];
            if (key.startsWith('fecha_') && val) {
              val = this.parseFecha(val);
            }
            return val;
          });
        });

        const csv = [orderedKeys, ...rows].map((row) => row.map(this.valorCSV).join(',')).join('\n');
        const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `reporte-inscripciones-${this.fechaInicio}-${this.fechaFin}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      valorCSV(value) {
        const text = String(value == null ? '' : value);
        return `"${text.replace(/"/g, '""')}"`;
      },
      cardExpandida(titulo) {
        return Boolean(this.cardsExpandidas[titulo]);
      },
      itemsVisiblesCard(card) {
        return this.cardExpandida(card.titulo)
          ? card.items
          : card.items.slice(0, this.limiteItemsCard);
      },
      toggleCardGerencia(titulo) {
        this.$set(this.cardsExpandidas, titulo, !this.cardExpandida(titulo));
      },
      toggleVistaGrafico(titulo) {
        this.$set(this.vistasGrafico, titulo, !this.esVistaGrafico(titulo));
      },
      esVistaGrafico(titulo) {
        return Boolean(this.vistasGrafico[titulo]);
      },
      obtenerChartData(card) {
        const labels = card.items.map(item => item.nombre);
        const data = card.items.map(item => item.total);

        const palette = [
          '#3f51b5', '#009688', '#9c27b0', '#ff9800', '#00bcd4',
          '#4caf50', '#e91e63', '#607d8b', '#795548', '#ff5722',
          '#673ab7', '#8bc34a', '#ffc107', '#03a9f4', '#cddc39'
        ];

        const backgroundColors = labels.map((_, i) => palette[i % palette.length]);

        return {
          labels,
          datasets: [
            {
              label: 'Registros',
              data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
            },
          ],
        };
      },
      obtenerChartOptions(card) {
        const isHorizontal = card.items.length > 6;
        if (isHorizontal) {
          return {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            scales: {
              xAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
              yAxes: [{ ticks: { fontSize: 10 } }],
            },
          };
        }
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: 'bottom',
            labels: { boxWidth: 10, fontSize: 10 },
          },
        };
      },
      parseFecha(f) {
        if (!f) return '';
        const fs = f.split(/[T ]/)[0].split('-');
        if (fs.length !== 3) return f;
        return `${fs[2]}/${fs[1]}/${fs[0]}`;
      },
      async listar_asesores(){
        this.asesores = []
        this.asesor = null
        if(!this.sedeSeleccionada) return;

        this.isLoadingAsesores = true;
        const sql = gql`query{ getSede(id:${this.sedeSeleccionada.idsede}){usuarios_activos{usuario{estado,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{cargo{id,nombre}},}}} }`;
        const data = await this.$apollo.query({ query: sql }).then((data) => data).catch((error) => error);
        this.isLoadingAsesores = false;
        const sed = data.data.getSede;
        const datas = [];
        if (sed.usuarios_activos == null) return;
        sed.usuarios_activos.forEach(function(e) {
          var dp = e.usuario.datos_personales;
          var seg = dp.seg_apellido == null ? '' : dp.seg_apellido;
          var no = dp.nombres + ' ' + dp.pri_apellido + ' ' + seg;
          let text = `${no} (${dp.id}) `;
          if (e.usuario.estado && e.usuario.datos_personales.id != 2)
            datas.push({ id: dp.id, nombres: no, text: text });
        });
        this.asesores = datas

        if(!this.sel_todos_asesores) {
          const id = this.$store.state.DATA_USER.id
          const ase = this.asesores.find(x=>x.id == id)
          this.asesor = ase;
          this.listar();
        }
      }
    },
    mounted() {
      this.setFechasDefault();
      this.habilitarcampos();
      this.listar_unidades();
      this.listar_convenios();
      if(this.sel_todos_asesores){
        this.listar();
      }
    },
  };
</script>

<style scoped>
.gerencia-card {
  height: 100%;
  overflow: hidden;
}

.gerencia-card__header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.gerencia-card__list,
.gerencia-card__chart {
  min-height: 210px;
}

.line-height-tight {
  line-height: 1.2;
}

.min-width-0 {
  min-width: 0;
}
</style>
